import React, { Component, createRef, ReactNode, TouchEvent } from 'react';
import classNames from 'classnames';

import './ptr.scss';
import LoadMore from '../LoadMore';
import { browser } from '../../utils/util';
/**
 *  A Pull to refresh container enable user to pull the container and refresh it's content
 *
 */
interface IPullToRefresh {
  height?: number | string;
  activeHeight?: number;
  loaderHeight?: number;
  loaderDefaultIcon?: (process: number) => ReactNode;
  loaderLoadingIcon?: ReactNode;
  onRefresh: (arg?: any) => PromiseLike<any>;
  disable?: boolean;
  className?: string;
  scrollerChildrenSelector?: string;
}

class PullToRefresh extends Component<IPullToRefresh> {
  static defaultProps = {
    height: window.screen.availHeight,
    loaderHeight: 80,
    activeHeight: window.innerHeight,
    loaderDefaultIcon: (progress: number) => {
      let style = {
        // transform: `rotate(-${progress !== 100 ? progress * 1.8 : 0}deg)`,
        color: progress !== 100 ? '#5f5f5f' : '#1AAD19'
      };
      return <LoadMore loading={true} style={{ height: '100%' }} />;
    },
    loaderLoadingIcon: <LoadMore loading={true} style={{ height: '100%' }} />,
    // onRefresh: () => new Promise(resolve => setTimeout(() => resolve(), 1000)),
    disable: false
  };
  state = {
    pullPercent: 0,
    touching: false,
    ogY: 0,
    touchId: undefined,
    animating: false,
    loading: false,
    initScrollTop: 0,
    message: [] as string[]
  };
  // 这个元素是拥有滚动条的元素！
  scrollEle = null as HTMLDivElement | null;

  coreDiv = createRef<HTMLDivElement>();

  constructor(props: IPullToRefresh) {
    super(props);
    this.resolveRefresh = this.resolveRefresh.bind(this);
  }

  resolveRefresh() {
    this.setState(
      {
        loading: false,
        animating: true,
        pullPercent: 0
      },
      () => {
        setTimeout(() => this.setState({ animating: false }), 500);
        // window.scrollTo(0, 0);
      }
    );
  }

  log(message: string) {
    const m = this.state.message;
    m.push(message);
    this.setState({
      message: m.splice(-10)
    });
  }

  handleTouchStart = (e: TouchEvent) => {
    if (this.state.touching || this.state.loading || this.props.disable) return;

    const $content = this.scrollEle;
    if (!$content) {
      return;
    }
    this.setState({
      touching: true,
      touchId: e.targetTouches[0].identifier,
      ogY:
        this.state.pullPercent === 0
          ? e.targetTouches[0].pageY
          : e.targetTouches[0].pageY - this.state.pullPercent,
      animating: false,
      initScrollTop: $content.scrollTop
    });
  };

  handleTouchMove = (e: TouchEvent) => {
    if (window.scrollY > 0) return;
    if (!this.state.touching || this.state.loading || this.props.disable)
      return;
    if (e.targetTouches[0].identifier !== this.state.touchId) return;

    const pageY = e.targetTouches[0].pageY;
    let diffY = pageY - this.state.ogY;
    // console.log(diffY, this.state.initScrollTop);

    //if it's scroll
    if (diffY < 0) return;

    //if it's not at top
    let $content = this.scrollEle;
    if (!$content) {
      return;
    }
    // this.log(diffY + ' ' + $content.scrollTop);
    if ($content.scrollTop > 0) return;
    //prevent move background
    // ios上因为会启用scroll刘畅滚动的东西，会导致这个不能完全阻止，所以ios上不做额外处理，让他能够随便拉下来
    if (browser.versions.android) {
      e.preventDefault();
    }

    diffY =
      diffY - this.state.initScrollTop > 100
        ? 100
        : diffY - this.state.initScrollTop;

    this.setState({
      pullPercent: diffY
    });
  };

  handleTouchEnd = () => {
    if (!this.state.touching || this.state.loading || this.props.disable)
      return;

    let pullPercent = this.state.pullPercent;
    let loading = false;

    if (pullPercent === 100) {
      loading = true;
    } else {
      pullPercent = 0;
    }

    // if(window.scrollY < this.props.activeHeight) {
    this.setState(
      {
        touching: false,
        ogY: 0,
        touchId: undefined,
        initScrollTop: 0,
        animating: loading,
        pullPercent,
        loading
      },
      () => {
        //triger after ui change
        if (loading) this.props.onRefresh().then(this.resolveRefresh);
      }
    );
    // }
  };

  bindScroll = () => {
    // passive:false可以用来阻止默认事件
    // 目前不得不阻止touchmove，否则会出现安卓微信下下滑会拉出网址的情况
    if (this.coreDiv && this.coreDiv.current) {
      // console.log('here1')

      this.coreDiv.current.addEventListener(
        'touchstart',
        // @ts-ignore
        this.handleTouchStart,
        { passive: false }
      );
      // @ts-ignore
      this.coreDiv.current.addEventListener('touchmove', this.handleTouchMove, {
        passive: false
      });
      this.coreDiv.current.addEventListener('touchend', this.handleTouchEnd, {
        passive: false
      });
    }
  };

  componentWillUnmount(): void {
    if (this.coreDiv && this.coreDiv.current) {
      // console.log('here2')

      this.coreDiv.current.removeEventListener(
        'touchstart',
        // @ts-ignore
        this.handleTouchStart
      );

      this.coreDiv.current.removeEventListener(
        'touchmove',
        // @ts-ignore
        this.handleTouchMove
      );
      this.coreDiv.current.removeEventListener('touchend', this.handleTouchEnd);
    }
  }

  componentDidMount(): void {
    this.scrollEle = document.querySelector(
      this.props.scrollerChildrenSelector || '.gallery-home'
    )! as HTMLDivElement;

    this.bindScroll();
  }

  render() {
    const {
      className,
      children,
      activeHeight,
      height,
      loaderHeight = 80,
      loaderDefaultIcon = () => null,
      loaderLoadingIcon,
      onRefresh,
      disable,
      scrollerChildrenSelector,
      ...domProps
    } = this.props;
    let cls = classNames('react-weui-ptr', className);
    // let { message } = this.state;

    let containerStyle = {
      // height,
    };

    let loaderStyle = {
      //transform: `translate(0, ${this.state.pullPercent / 2}px)`,
      height: loaderHeight,
      marginTop: `${-loaderHeight +
        this.state.pullPercent / (100 / loaderHeight)}px`,
      transition: this.state.animating ? 'all .5s' : 'none'
    };

    return (
      <div className={cls} style={containerStyle} {...domProps}>
        <div className="react-weui-ptr__loader" style={loaderStyle}>
          {this.state.loading
            ? loaderLoadingIcon
            : loaderDefaultIcon(this.state.pullPercent)}
        </div>
        <div
          className="react-weui-ptr__content"
          ref={this.coreDiv}
          // onTouchStart={this.handleTouchStart}
          // onTouchMove={this.handleTouchMove}
          // onTouchEnd={this.handleTouchEnd}
        >
          {children}
        </div>
      </div>
    );
  }
}

export default PullToRefresh;
